import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/ui/Layout";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Services from "./pages/services/Services";
import SingleService from "./pages/singleservice/SingleService"; // Import the new component
import Workshops from "./pages/workshops/Workshops";
import Blogs from "./pages/blogs/Blogs";
import SingleBlogPage from "./pages/SingleBlog/SingleBlogPage";
import { SingleWorkshopPage } from "./pages/SingleWorkshop/SingleWorkshopPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "about", element: <About /> },
      { path: "services", element: <Services /> },
      { path: "services/:serviceName", element: <SingleService /> }, // Add dynamic route for each service
      { path: "workshops", element: <Workshops /> },
      { path: "blogs", element: <Blogs /> },
      { path: "blogs/:blogTitle", element: <SingleBlogPage /> },
      { path: "workshops/:workshopTitle", element: <SingleWorkshopPage /> },
      { path: "*", element: <div>Page not found</div> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
